const styles = (theme) => ({
  container: {
    width: "100%",
    alignItems: "center",
    flexDirection: "column",
    display: "flex",
  },
  paper: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    position: "relative",
    overflow: "hidden",
  },
  buttomAddUser: {
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
    maxWidth: "200px",
    "@media (max-width: 1350px)": {
      maxWidth: "200px",
    },
  },
  containerUserErp: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  chipUserErp: {
    maxWidth: "100%",
    backgroundColor: theme.palette.action.hover,
    fontWeight: 500,
    "& .MuiChip-label": {
      display: "block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis", // Aplica os 3 pontinhos
    },
  },
  searcField: {
    width: "250px",
    display: "flex",
    fontSize: "0.90rem", // diminui fonte geral
    "& .MuiInputBase-input": {
      padding: "8px 10px", // padding interno reduzido
      fontSize: "0.90rem", // fonte do input
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.90rem", // fonte da label
    },
    "@media (max-width: 1350px)": {
      width: "100%",
    },
  },
  containerAvatar: { width: "35px", height: "35px" },
  BoxStack: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media (max-width: 664px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 2,
      height: "auto",
    },
    padding: "0px 20px 0px 20px",
  },
  containerBuscar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 2,
    mt: 2,
    mb: 2,
  },
  containerButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  containerAdd: {
    marginTop: "-3px",
  },
  containerPrimeiroAcesso: {
    cursor: "pointer",
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  person: {
    color: theme.palette.colors.green.light,
  },
  personOff: {
    color: theme.palette.colors.orange.medium,
  },
  containerIconTime: {
    fontSize: "15px",
    color: theme.palette.colors.orange.medium,
    zIndex: 1,
    position: "absolute",
    bottom: 4,
    left: 11,
    bottom: 16,
    borderRadius: "50%",
  },
  conatinerChip: {
    display: "flex",
    alignItems: "center",
  },
  chipPermissoes: {
    fontWeight: 500,
    color: theme.palette.white.main,
    width: "100px",
  },
  dataGrid: {
    display: "grid",
    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
      py: "5px",
    },
    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {},
    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
      py: "22px",
    },
    fontSize: 15,
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
  },
  searchField: {
    width: "250px",
    display: "flex",
    fontSize: "0.90rem", // diminui fonte geral
    "& .MuiInputBase-input": {
      padding: "8px 10px", // padding interno reduzido
      fontSize: "0.90rem", // fonte do input
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.90rem", // fonte da label
    },
    "@media (max-width: 1350px)": {
      width: "100%",
    },
  },
});

export default styles;
